export enum KeywordsModeEnum {
  GROWTH = 'growth',
  POPULARITY = 'popularity'
}
